export const HYPHEN_VALUE = '-'

export const isHyphen = (value?: string | null) => value?.trim() === HYPHEN_VALUE

export const isEmptyOrHyphen = (value?: string | null) => !value?.trim() || isHyphen(value)
